module.exports = __webpack_public_path__ + "img/3bhk-a1.3f6758a0.jpg";